export const DEFAULT_CATERING_CONTENT = {
  heroHeading: 'Bring the Peanut Shack to Your Next Event',
  heroHighlight: 'Peanut Shack',
  heroDescription: "Aunt Jack's serves fresh, small-batch boiled peanuts with setup and friendly on-site service for parties, reunions, tailgates, fundraisers, and company gatherings across Northeast Georgia.",
  heroStartingPrice: 'Packages start at $6 per person · 40-person minimum',
  packagesHeading: 'Choose Your Peanut Bar',
  packagesIntro: 'Every package includes serving cups, a complete peanut bar setup, and up to two hours of friendly on-site service.',
  packages: [
    {
      name: 'Classic Peanut Bar',
      pricePerPerson: 6,
      minimumGuests: 40,
      minimumTotal: 240,
      description: '2 flavors, your choice of heat levels, cups, setup, and service.',
    },
    {
      name: 'Custom Peanut Bar',
      pricePerPerson: 7,
      minimumGuests: 40,
      minimumTotal: 280,
      description: 'Up to 3 flavors, including one custom flavor, multiple heat levels, cups, setup, and service.',
    },
    {
      name: 'Premium Peanut Bar',
      pricePerPerson: 8,
      minimumGuests: 40,
      minimumTotal: 320,
      description: 'Up to 4 standard or custom flavors, full-variety setup, cups, and service.',
    },
  ],
  largeEventNote: 'Planning for 75 or more guests? Ask about custom large-event pricing.',
  detailsHeading: 'Travel, Add-ons & Details',
  travel: [
    { label: 'Within 15 miles', price: 'Included', minimumMiles: 0, maximumMiles: 15, fee: 0 },
    { label: '16–30 miles', price: '+$50', minimumMiles: 15.1, maximumMiles: 30, fee: 50 },
    { label: '31–50 miles', price: '+$100', minimumMiles: 30.1, maximumMiles: 50, fee: 100 },
  ],
  addOns: [
    { label: 'Additional flavor', price: '+$35', pricingMode: 'per_unit', unitPrice: 35, minimumPrice: null, maximumPrice: null, unitLabel: 'flavor' },
    { label: 'Special or custom flavor', price: '+$25–$50', pricingMode: 'custom_range', unitPrice: null, minimumPrice: 25, maximumPrice: 50, unitLabel: 'flavor' },
    { label: 'Extra-heavy serving', price: '+$2/person', pricingMode: 'per_person', unitPrice: 2, minimumPrice: null, maximumPrice: null, unitLabel: 'person' },
    { label: 'Frozen take-home bags', price: '$20 each', pricingMode: 'per_unit', unitPrice: 20, minimumPrice: null, maximumPrice: null, unitLabel: 'bag' },
    { label: 'Additional serving hour', price: '+$50/hour', pricingMode: 'per_unit', unitPrice: 50, minimumPrice: null, maximumPrice: null, unitLabel: 'hour' },
  ],
  marketNote: 'Catering prices are based on current market pricing and may vary for specialty flavors, unusually large events, or significant changes in peanut availability.',
  contactHeading: "Let's plan your next boil",
  contactDescription: "Tell Jackie your date, guest count, location, and favorite flavors. She'll confirm availability and prepare a custom quote.",
  phone: '706-248-5702',
  email: 'carjack@myyahoo.com',
  serviceArea: 'Serving events within approximately 50 miles of Colbert, Georgia.',
  seoTitle: "Boiled Peanut Catering | Aunt Jack's Peanut Shack",
  seoDescription: "Book Aunt Jack's staffed boiled peanut bar for parties, reunions, tailgates, fundraisers, and company events within about 50 miles of Colbert, Georgia.",
  invoicePaymentTerms: 'Payment due at the event (COD).',
  invoiceFooterNote: "Thank you for choosing Aunt Jack's Peanut Shack.",
};

export function cloneCateringContent(content = DEFAULT_CATERING_CONTENT) {
  const merged = { ...DEFAULT_CATERING_CONTENT, ...content };
  return {
    ...merged,
    packages: merged.packages.map((item) => ({ ...item })),
    travel: merged.travel.map((item) => ({ ...item })),
    addOns: merged.addOns.map((item) => ({ ...item })),
  };
}
